import { Checkbox } from "antd";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { setGlobalTripStatus, setGlobalIsGetDetail} from "../../../store/reducer/globalMultipleSearchSelect.reducer";

const MSSTripStatus = ({
  setValueMSS,
  valueMSS,
  children,
  togglerClassName,
  placeholder,
  className,
  filterByGrologAccountId,
  ...attrs
}) => {
  const dispatch = useDispatch();

  const dropdownRef = useRef(null);
  const dropdownContentRef = useRef(null);
  const btnDropdownRef = useRef(null);
  const [isShowDropdownContent, setIsShowDropdownContent] = useState(false);
  const [totalData, setTotalData] = useState(4);
  const [listSelected, setListSelected] = useState([]);
  const [isSelectedAll, setIsSelectedAll] = useState(false);
  const {
    globalDepotName,
    globalDA,
    globalOrderStatus,
    globalTrip,
    globalTripStatus,globalIsGetDetail
  } = useSelector((state) => state.globalMSS);
  
  const listData = useMemo(() => {
    const list = [
      { id: "ALL", name: "All Trip Statuss" },
      { id: "Not Started", name: "Not Started" },
      { id: "Start", name: "Start" },
      { id: "Shipment", name: "Shipment" },
      { id: "Pick Up", name: "Pick Up" },
    ];
    return list;
  }, []);
  const togglerDropdownContent = useCallback(() => {
    setIsShowDropdownContent((state) => !state);
  }, []);
  useEffect(() => {
    const handleClick = (event) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current.contains(event?.target) &&
        dropdownContentRef?.current?.classList.contains("active")
      ) {
        setIsShowDropdownContent(false);
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document?.removeEventListener("click", handleClick);
    };
  }, []);

  useEffect(()=>{
    if(globalIsGetDetail){
    setListSelected(
      // globalDepotName.every(item => item >= 0) ? 
      // globalDepotName.map((item)=> {
      // return { id: item }}) : globalDepotName)
      globalTripStatus?.every(item => item !== "ALL")&& typeof globalTripStatus[0] !== 'object' ? 
      listData?.filter(itemB => globalTripStatus?.includes(itemB?.id)): globalTripStatus)
    
      dispatch(setGlobalIsGetDetail(false))
    }
    // dispatch(setGlobalIsGetDetail(true))
  },[globalTripStatus])

  console.log("global",  globalTripStatus, listData, listSelected);
  const isCheckedSelectAll = useMemo(() => {
    if (listSelected !== undefined && listSelected.length === totalData) {
      setIsSelectedAll(true);
      return true;
    }
    setIsSelectedAll(false);
    return false;
  }, [listSelected, totalData]);

  const isCheckedPerItem = useCallback(
    (item) => {
      if (listSelected.length > 0) {
        if (listSelected.length === totalData || listSelected.includes("ALL")) {
          return true;
        }
        const isExist = listSelected.some((el) => el.id === item.id);
        return isExist;
      }
      return false;
    },
    [listSelected, totalData]
  );

  const isAllDepot = useMemo(() => {
    if (listSelected.length) {
      if (listSelected.includes("ALL")) {
        return true;
      }
      const length = listSelected.length;
      if (listSelected.length > 0 && length === totalData) {
        return true;
      }
    }
    return false;
  }, [listSelected, totalData]);


  const handleClickSelectData = useCallback(
    (item) => {
      if (item?.id === "ALL") {
        if (listSelected.length === 0 || !listSelected) {
          setListSelected(["ALL"]);
          dispatch(setGlobalTripStatus(["ALL"]));
          return;
        }
        if (listSelected.length && listSelected.length - 1 !== totalData) {
          if (listSelected.includes("ALL")) {
            setListSelected([]);
            dispatch(setGlobalTripStatus([]));
            return;
          }
          setListSelected(["ALL"]);
          dispatch(setGlobalTripStatus(["ALL"]));
          return;
        }
        if (listSelected.length && listSelected.includes("ALL")) {
          setListSelected([]);
          dispatch(setGlobalTripStatus([]));
        }

        return;
      }
      if (item?.id !== "ALL") {
        if (listSelected.length === 0) {
          const listDataSelected = listSelected;
          listDataSelected.push(item);
          setListSelected([...listDataSelected]);
          dispatch(setGlobalTripStatus([...listDataSelected]));
          return;
        }
        const isAllSelected = listSelected.includes("ALL");

        if (isAllSelected) {
          const idFiltering = ["ALL"];
          idFiltering.push(item?.id);
          const newList = listData.filter(
            (el) => !idFiltering.includes(el?.id)
          );
          setListSelected([...newList]);
          dispatch(setGlobalTripStatus([...newList]));
          return;
        }
        const isExist = listSelected.some((el) => el?.id === item?.id);
        if (isExist) {
          const listDataFiltered = listSelected.filter(
            (el) => el?.id !== item?.id
          );
          setListSelected([...listDataFiltered]);
          dispatch(setGlobalTripStatus([...listDataFiltered]));
          return;
        } else {
          const list = listSelected;
          list.unshift(item);
          setListSelected([...list]);
          dispatch(setGlobalTripStatus([...list]));
          return;
        }
      }
    },
    [dispatch, listData, listSelected, totalData]
  );

  return (
    <div
      className={"dropdown-dds".concat(className ? ` ${className}` : "")}
      {...attrs}
      ref={dropdownRef}
    >
      <button
        className="value-mss"
        onClick={togglerDropdownContent}
        ref={btnDropdownRef}
      >
        {isAllDepot ? (
          <span className="list-value-mss">All Trip Status</span>
        ) : isCheckedSelectAll === false && listSelected.length !== 0 ? (
          listSelected.map((item, index) => (
            <span key={index} className="list-value-mss">
              {item?.name}
            </span>
          ))
        ) : (
          <span className="placeholder-mss">Select Trip Status</span>
        )}
      </button>
      <div></div>
      <div
        className={"dropdown-dds-menu".concat(
          isShowDropdownContent ? " active mt-2 pb-10" : ""
        )}
        ref={dropdownContentRef}
      >
        <div className="overflow-auto max-h-[300px]">
          {listData?.map((el, index) => (
            <div
              key={index}
              className={"dropdown-dds-item truncate"}
              onClick={() => handleClickSelectData(el)}
            >
              <div className="w-full flex justify-between px-2">
                <span>{el?.name}</span>
                <Checkbox checked={isCheckedPerItem(el)} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MSSTripStatus;
